import {
    Collapse, Divider,
    List,
    ListItemButton as MuiListItemButton,
    ListItemButtonProps, ListItemButtonTypeMap,
    ListItemIcon,
    ListItemText as MuiListItemText, Theme
} from "@mui/material";

import {styled} from "@mui/material/styles";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import React, {useContext} from "react";
import ResponsibleGaming from "../../../../components/Icons/ResponsibleGaming";
import {useLocation, useNavigate} from "react-router-dom";
import {CustomLink} from "../../../../components/CustomLink/CustomLink";
import {useMutation} from "@apollo/client";
import {LOGOUT_MUTATION} from "../../../../store/mutations/Logout";
import {GET_USER} from "../../../../store/queries/GetUser";
import {RouteContext} from "../../../../routes/RouteContext";
import {useTranslation} from "react-i18next";
import CreditCard from "../../../../components/Icons/CreditCard";
import Account from "../../../../components/Icons/Account";
import {UserBadge} from "../details/UserBadge";
import {UserDetails} from "../details/UserDetails";


const ListItemText = styled(MuiListItemText)(({theme}) => ({
    '.Mui-selected &': {
        color: theme.palette.primary.main,
        '& span': {
            fontWeight: 700
        }
    }
}));

export const Navigation = ({
                               callBack,
                               showLogout,
                               variant = 'normal',
                               showUserDetails = false
                           }: { callBack?: (() => void), variant?: 'dense' | 'normal' | 'withoutCollapse', showLogout: boolean, showUserDetails?: boolean }) => {
    const {t} = useTranslation();
    let routeContext = useContext(RouteContext);
    let navigate = useNavigate();
    const [open, setOpen] = React.useState({
        transactions: true,
        account: true,
        responsible: true
    });
    const [logout, _] = useMutation(LOGOUT_MUTATION, {
        update(cache, {data}) {

            cache.writeQuery({
                data: {identity: data.logout},
                query: GET_USER
            });

        }
    });
    const handleClick = (key: keyof typeof open) => {
        if (!(variant == 'dense'))
            setOpen({...open, [key]: !open[key]});
    };

    const ListItemButton = React.forwardRef<HTMLAnchorElement, ListItemButtonProps<ListItemButtonTypeMap['defaultComponent'],
        { to: string, dense: boolean, children?: React.ReactNode }>>(
        (props, ref) => {
            let location = useLocation();

            let from = location.pathname || "/";
            const {children, onClick, to, sx, ...restProps} = props;
            return (
                <MuiListItemButton component={CustomLink} ref={ref} sx={{...sx, pl: !(variant != 'normal') ? 11 : 7}}
                                   selected={from == to} to={to} onClick={callBack} {...restProps as any}
                                   disableRipple>{children}</MuiListItemButton>)
        });

    const listIconStyle = variant != 'normal' ? {minWidth: 40} : {};
    const iconStyle = variant != 'normal' ? {
            height: 24,
            width: 24,
            color: (theme: Theme) => theme.palette.primary.main
        } :
        {height: 40, width: 40, color: (theme: Theme) => theme.palette.primary.main};
    return (<>
        {showUserDetails && <UserDetails isMobile hideDeposit/>}
        <List
            sx={{width: '100%', bgcolor: 'background.paper'}}
            component="nav"

        >
            <MuiListItemButton disabled={variant != 'normal'} disableRipple dense={variant == 'dense'}
                               sx={{pl: (variant == 'normal') ? 4 : 2, opacity: '1 !important'}}
                               onClick={(e) => {
                                   handleClick('transactions');
                                   e.preventDefault();
                               }}>
                <ListItemIcon sx={listIconStyle}>
                    <CreditCard sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary={t('transactions')} sx={{'& span': {fontWeight: 700}}}/>
                {variant != 'normal' ? <></> : open.transactions ? <ExpandLess/> : <ExpandMore/>}
            </MuiListItemButton>
            <Collapse in={open.transactions} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton dense={(variant == 'dense')} to={'/withdraw'}
                                    sx={{pl: !(variant == 'dense') ? 11 : 9}}>
                        <ListItemText primary={t('withdraw')}/>
                    </ListItemButton>
                    <ListItemButton dense={(variant == 'dense')} to={'/transactions-history'}
                                    sx={{pl: !(variant == 'dense') ? 11 : 9}}>
                        <ListItemText primary={t('transactionHistory')}/>
                    </ListItemButton>
                </List>
            </Collapse>
            <MuiListItemButton disabled={variant != 'normal'} disableRipple dense={(variant == 'dense')}
                               sx={{pl: !(variant != 'normal') ? 4 : 2, opacity: '1 !important'}}
                               onClick={() => handleClick('account')}>
                <ListItemIcon sx={listIconStyle}>
                    <Account sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary={t('myAccount')} sx={{'& span': {fontWeight: 700}}}/>
                {variant != 'normal' ? <></> : open.account ? <ExpandLess/> : <ExpandMore/>}
            </MuiListItemButton>
            <Collapse in={open.account} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton dense={(variant == 'dense')} to={'/details'}>
                        <ListItemText primary={t('myDetails')}/>
                    </ListItemButton>
                    <ListItemButton dense={(variant == 'dense')} to={'/documents'}>
                        <UserBadge navigation={true}><ListItemText primary={t('documents')}/> </UserBadge>
                    </ListItemButton>
                    {/*<ListItemButton dense={dense}  to={'/messages'}sx={{pl: dense? 11: 9 }}>*/}
                    {/*    <ListItemText primary="Messages" />*/}
                    {/*</ListItemButton>*/}
                    <ListItemButton dense={(variant == 'dense')} to={'/game-history'}>
                        <ListItemText primary={t('gameHistory')}/>
                    </ListItemButton>
                    <ListItemButton dense={(variant=='dense')} to={'/tournament-history'} >
                        <ListItemText primary={t('tournamentHistory')}/>
                    </ListItemButton>

                </List>
            </Collapse>
            <MuiListItemButton disabled={variant != 'normal'} disableRipple dense={(variant == 'dense')}
                               sx={{pl: !(variant != 'normal') ? 4 : 2, opacity: '1 !important'}}
                               onClick={() => handleClick('responsible')}>
                <ListItemIcon sx={listIconStyle}>
                    <ResponsibleGaming sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary={t('playResponsibly')} sx={{'& span': {fontWeight: 700}}}/>
                {variant != 'normal' ? <></> : open.responsible ? <ExpandLess/> : <ExpandMore/>}
            </MuiListItemButton>
            <Collapse in={open.responsible} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton dense={(variant == 'dense')} to={'/limits'}>
                        <ListItemText primary={t('limits')}/>
                    </ListItemButton>
                    <ListItemButton dense={(variant == 'dense')} to={'/self-exclusion'}>
                        <ListItemText primary={t('selfExclusion')}/>
                    </ListItemButton>
                </List>
            </Collapse>
            {showLogout && (
                <>
                    <Divider/>
                    <List component="div" disablePadding>
                        <MuiListItemButton dense={(variant == 'dense')} sx={{pl: !(variant != 'normal') ? 5 : 3}}
                                           onClick={(e) => {
                                               callBack?.();

                                               if (routeContext.currentRouteIsProtectedRoute)
                                                   navigate('/');
                                               logout({
                                                   variables: {},

                                                   onCompleted(data) {

                                                   }
                                               })
                                           }}>
                            <ListItemText primary={t('logout')}/>
                        </MuiListItemButton>
                    </List>
                </>)}
        </List>
    </>);
}